module.exports = __webpack_public_path__ + "assets/img/5.b4a8acd6.png";